import { useState } from "react";

export const useOIDCValidation = () => {
  const [validationStatus, setValidationStatus] = useState<
    "idle" | "loading" | "success" | "error"
  >("idle");
  const [validationMessage, setValidationMessage] = useState<string | null>(
    null
  );

  const validateConfiguration = async (authority?: string) => {
    if (!authority) return;

    setValidationStatus("loading");
    setValidationMessage(null);

    try {
      const url = `${authority.replace(
        /\/$/,
        ""
      )}/.well-known/openid-configuration`;
      const response = await fetch(url);

      if (response.ok) {
        await response.json();
        setValidationStatus("success");
        setValidationMessage("Authority is valid and reachable!");
      } else {
        setValidationStatus("error");
        setValidationMessage(
          `Failed to reach OIDC Discovery endpoint: ${response.statusText}`
        );
      }
    } catch (error) {
      setValidationStatus("error");
      setValidationMessage(
        error instanceof Error ? error.message : "An unknown error occurred"
      );
    }
  };

  const resetValidation = () => {
    setValidationStatus("idle");
    setValidationMessage(null);
  };

  return {
    validationStatus,
    validationMessage,
    validateConfiguration,
    resetValidation,
  };
};
